import { CREATE_NEW_CONSIGNMENT_FROM_RECEIVAL_LOT_FORM } from "constants/actionTypes";
import { FormikSnapshot } from "sagas/modals/util";

type ReceivalLotFormValues = object;

export interface CreateConsignmentAction {
  type: typeof CREATE_NEW_CONSIGNMENT_FROM_RECEIVAL_LOT_FORM;
  receivalLotId: string;
  formikSnapshot: FormikSnapshot<ReceivalLotFormValues>;
}

export function createConsignmentFromReceivalLotForm(
  receivalLotId: string,
  formikSnapshot: FormikSnapshot<ReceivalLotFormValues>,
): CreateConsignmentAction {
  return {
    type: CREATE_NEW_CONSIGNMENT_FROM_RECEIVAL_LOT_FORM,
    receivalLotId,
    formikSnapshot,
  };
}
